<template>
  <div class="main-container clearfix">
    <div class="bread w_bfb">
      <router-link :to="{ name: 'Index' }">首页</router-link>
      <span class="slash">/</span>
      <router-link
        :to="{
          name: 'ShowTeachersDetaial',
          params: { id: teacher_id },
          query: { route_name: 'ShowTeachers', route_label: '名师' },
        }"
      >
        讲师详情
      </router-link>
      <span class="slash">/</span>
      <span class="current">咨询中心</span>
    </div>

    <ConsultUpvoteStatus
      :tabs="tabs"
      :list="list"
      :isData="isData"
      :params="params"
      :page="page"
      :limit="limit"
      :total="total"
      :detail="detail"
      getPage="TeacherAdminIndex"
    ></ConsultUpvoteStatus>
    <div class="w_bfb" style="height: 20px"></div>
    <el-dialog
      title="发起咨询"
      :visible.sync="addConsult.showDialog"
      width="500px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="reset-phone-dialog"
    >
      <el-form
        :model="addConsult.dataForm"
        :rules="addConsult.dataRules"
        ref="addConsult"
        label-width="80px"
      >
        <el-form-item label="咨询主题" prop="title">
          <div class="box">
            <el-input
              v-model="addConsult.dataForm.title"
              style="width: 300px"
              placeholder="请输入咨询的主题"
              maxlength="20"
            ></el-input>
            <CharCount :text="addConsult.dataForm.title" :max="20"></CharCount>
          </div>
        </el-form-item>
        <el-form-item label="咨询内容" prop="details">
          <div class="box">
            <el-input
              v-model="addConsult.dataForm.details"
              style="width: 300px"
              placeholder="请输入咨询的内容"
              type="textarea"
              maxlength="500"
              :autosize="{ minRows: 4, maxRows: 4 }"
            ></el-input>
            <CharCount
              :text="addConsult.dataForm.details"
              :max="500"
            ></CharCount>
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addConsult.showDialog = false">取消</el-button>
        <el-button
          type="primary"
          :disabled="!addConsult.dataForm.title || !addConsult.dataForm.details"
          @click="submitAddConsult"
        >
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CharCount from "@/components/CharCount";
import ConsultUpvoteStatus from "@/components/ConsultUpvoteStatus.vue";
export default {
  name: "TeacherAdminIndex",
  components: {
    ConsultUpvoteStatus,
    CharCount,
  },
  data() {
    return {
      tabs: [
        { name: "0", label: "全部" },
        // { name: "1", label: "我的咨询" },
      ],
      addConsult: {
        showDialog: false,
        dataForm: {
          title: "",
          details: "",
          teacher_id: this.$route.query.teacher_id,
        },
        dataRules: {
          title: [
            { required: true, message: "请输入要咨询的主题", trigger: "blur" },
          ],
          details: [
            { required: true, message: "请输入要咨询的内容", trigger: "blur" },
          ],
        },
      },
      detail: {},
      list: [],
      page: 1,
      limit: 6,
      total: 0,
      isData: 1,
      teacher_id: this.$route.query.teacher_id,
      params: {
        is_my: 0,
        teacher_id: this.$route.query.teacher_id,
      },
    };
  },
  computed: {},
  watch: {
    "params.is_my": {
      handler() {
        this.page = 1;
        this.getData();
      },
    },
  },
  async created() {
    await this.getData();
  },
  methods: {
    //点赞
    async handleZan(item) {
      await this.$http.get(`/api/app/teacher/consult/upvoteStatus`, {
        id: item.id,
      });
      this.$message({
        message: item.is_upvote == 0 ? "点赞成功！" : "取消点赞成功！",
        type: "success",
      });
      await this.getData();
    },
    async delConsult(item) {
      await this.$promiseConfirm("删除后，该内容将不再展示，是否确认？", {
        type: "warning",
      });
      await this.$http.delete(`/api/app/teacher/consult/userDelete/` + item.id);
      this.page = 1;
      await this.getData();
    },
    async submitAddConsult() {
      this.$refs["addConsult"].validate(async valid => {
        if (!valid) {
          return;
        }
        await this.$http.post(
          "/api/app/teacher/consult/addConsult",
          this.addConsult.dataForm,
        );
        this.$success("发起咨询完成");
        this.page = 1;
        this.params.is_my = "1";
        this.addConsult.showDialog = false;
        await this.getData();
      });
    },
    consultAddConsult() {
      this.addConsult.dataForm.title = "";
      this.addConsult.dataForm.details = "";
      this.addConsult.showDialog = true;
    },
    async handlePageChange(page) {
      this.page = page;
      await this.getData();
    },
    async getData() {
      let data = await this.$http.get("/api/app/teacher/consult/index", {
        order_type: this.current,
        page: this.page,
        is_my: this.params.is_my,
        teacher_id: this.params.teacher_id,
        limit: this.limit,
      });
      this.detail = data.extra;
      if (data.data && data.data.length > 0) {
        this.isData = 1;
      } else {
        this.isData = 0;
      }
      data.data.forEach(item => {
        if (item.recover_info && item.recover_info.image) {
          item.recover_info.image = item.recover_info.image.split(",");
        }
      });
      this.list = data.data;
      this.total = data.total;
    },
  },
};
</script>

<style lang="scss" scoped></style>
